import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getLocalMatchTime } from "../../utils/matchTimeConverter";

const IPLMatchCardUpcoming = ({ match }) => {
  const [timeLeft, setTimeLeft] = useState({
    hours: "00",
    minutes: "00",
    seconds: "00",
    days: "00",
  });

  // =========================
  // COUNTDOWN TIMER
  // ==== =====================

  // console.log(match, 'ooo')
  const result =
    getLocalMatchTime({
      country: match?.country_name,
      matchDate: match?.match_date,
      matchTime: match?.match_time,
    });
  useEffect(() => {

      const targetDate = new Date(
        `${result?.localDate}T${result?.localTime}`
      );
     
    const interval = setInterval(() => {
      const now = new Date();

      const difference = targetDate - now;

      if (difference <= 0) {
        clearInterval(interval);

        setTimeLeft({
          days: "00",
          hours: "00",
          minutes: "00",
          seconds: "00",
        });

        return;
      }

      const days = Math.floor(
        difference / (1000 * 60 * 60 * 24)
      );

      const hours = Math.floor(
        (difference / (1000 * 60 * 60)) % 24
      );

      const minutes = Math.floor(
        (difference / (1000 * 60)) % 60
      );

      const seconds = Math.floor(
        (difference / 1000) % 60
      );

      setTimeLeft({
        days: String(days).padStart(2, "0"),

        hours: String(hours).padStart(2, "0"),
        minutes: String(minutes).padStart(2, "0"),
        seconds: String(seconds).padStart(2, "0"),
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [match]);

  return (
    <Link to={`/match/${match?.match_id}`}>
      <div className="relative overflow-hidden rounded-2xl cursor-pointer group transition-all duration-300">

        <div className="relative bg-white dark:bg-[#121212] border border-gray-200 dark:border-gray-700 rounded-2xl overflow-hidden shadow-md group-hover:shadow-xl group-hover:border-blue-500/50 transition-all">

          {/* Top Bar */}
          <div className="h-1 w-full bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500" />

          {/* League Logo */}
          <div className="absolute top-3 right-3 z-10">
            <div className="w-10 h-10 rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-[#1e1e1e] shadow-md flex items-center justify-center overflow-hidden">
              <img
                src={match?.league_logo}
                alt={match?.league_name}
                className="w-full h-full object-contain"
              />
            </div>
          </div>

          <div className="p-4">

            {/* League */}
            <div className="text-center mb-3">
              <h3 className="text-base md:text-lg font-semibold text-gray-900 dark:text-white">
                {match?.league_name}
              </h3>

              <div className="flex items-center justify-center gap-2 mt-1">
                <div className="h-px w-8 bg-gradient-to-r from-transparent to-blue-500" />

                <span className="text-xs font-semibold text-blue-500">
                  {match?.league_year}
                </span>

                <div className="h-px w-8 bg-gradient-to-l from-transparent to-blue-500" />
              </div>
            </div>

            {/* Match Info */}
            <div className="flex items-center justify-between mb-3">

              <span className="text-xs font-semibold px-3 py-1 rounded-full border border-blue-500/30 text-blue-500 bg-blue-500/10">
                ⚽ Football
              </span>

              <div className="flex items-center gap-2">
                <span className="text-yellow-500">⭐</span>

                <span className="text-xs text-gray-500 dark:text-gray-400 bg-gray-100 dark:bg-gray-800 px-3 py-1 rounded-full">
                  Round {match?.match_round}
                </span>
              </div>

            </div>

            {/* Teams */}
            <div className="flex items-center justify-between gap-2">

              {/* Home Team */}
              <div className="flex-1 flex flex-col items-center text-center">

                <div className="w-14 h-14 md:w-16 md:h-16 bg-white dark:bg-[#1e1e1e] border border-gray-200 dark:border-gray-700 rounded-xl flex items-center justify-center p-2 overflow-hidden">

                  <img
                    src={match?.team_home_badge}
                    alt={match?.match_hometeam_name}
                    className="w-full h-full object-contain"
                  />

                </div>

                <p className="text-xs md:text-sm mt-1 text-gray-700 dark:text-gray-300 font-medium">
                  {match?.match_hometeam_name}
                </p>

              </div>

              {/* Timer */}
              <div className="flex flex-col items-center px-1">

                <span className="text-[11px] text-blue-500 font-bold uppercase">
                  Starts In
                </span>

                <div className="flex items-center gap-1 mt-1">
                  <div className="text-center">
                    <div className="bg-gray-100 dark:bg-gray-800 px-2 py-1 rounded-md min-w-[32px]">
                      <span className="font-bold">
                        {timeLeft.days}
                      </span>
                    </div>

                    <span className="text-[9px] text-gray-500">
                      DAY
                    </span>
                  </div>

                  {/* <span>:</span> */}
                  <div className="text-center">
                    <div className="bg-gray-100 dark:bg-gray-800 px-2 py-1 rounded-md min-w-[32px]">
                      <span className="font-bold">
                        {timeLeft.hours}
                      </span>
                    </div>

                    <span className="text-[9px] text-gray-500">
                      HRS
                    </span>
                  </div>

                  {/* <span>:</span> */}

                  <div className="text-center">
                    <div className="bg-gray-100 dark:bg-gray-800 px-2 py-1 rounded-md min-w-[32px]">
                      <span className="font-bold">
                        {timeLeft.minutes}
                      </span>
                    </div>

                    <span className="text-[9px] text-gray-500">
                      MIN
                    </span>
                  </div>

                  {/* <span>:</span> */}

                  <div className="text-center">
                    <div className="bg-gray-100 dark:bg-gray-800 px-2 py-1 rounded-md min-w-[32px]">
                      <span className="font-bold">
                        {timeLeft.seconds}
                      </span>
                    </div>

                    <span className="text-[9px] text-gray-500">
                      SEC
                    </span>
                  </div>

                </div>

              </div>

              {/* Away Team */}
              <div className="flex-1 flex flex-col items-center text-center">

                <div className="w-14 h-14 md:w-16 md:h-16 bg-white dark:bg-[#1e1e1e] border border-gray-200 dark:border-gray-700 rounded-xl flex items-center justify-center p-2 overflow-hidden">

                  <img
                    src={match?.team_away_badge}
                    alt={match?.match_awayteam_name}
                    className="w-full h-full object-contain"
                  />

                </div>

                <p className="text-xs md:text-sm mt-1 text-gray-700 dark:text-gray-300 font-medium">
                  {match?.match_awayteam_name}
                </p>

              </div>

            </div>

            {/* Footer */}
            <div className="mt-3 pt-2 border-t border-gray-200 dark:border-gray-700 text-center space-y-1">

              <p className="text-xs text-gray-500 dark:text-gray-400 flex items-center justify-center gap-1">
                📍 {match?.match_stadium}
              </p>

              <p className="text-xs text-gray-500 dark:text-gray-400">
                <span className="text-blue-500 font-semibold">
                  {result?.localDate}
                </span>{" "}
                • {result?.localTime}
              </p>

              <span className="inline-block bg-blue-500/20 text-blue-500 px-3 py-1 text-xs rounded-full font-semibold">
                Upcoming
                {/* {match?.match_status} */}
              </span>

            </div>

          </div>

        </div>
      </div>
    </Link>
  );
};

export default IPLMatchCardUpcoming;